import axios, { AxiosRequestHeaders } from "axios";
import { store } from "store/store";
import i18n from "i18next";
import { logout } from "store/auth/reducer";

const APP_URL = process.env.REACT_APP_OMANA_URL;

export const apiCall = (additionalHeaders?: AxiosRequestHeaders) => {
  const instance = axios.create({
    baseURL: APP_URL,
    headers: {
      "X-Locale": i18n.language,
      ...additionalHeaders,
    },
  });

  instance.interceptors.request.use((config) => {
    const token = store.getState().auth.token;
    if (token && config.headers) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
        store.dispatch(logout());
      }
      return Promise.reject(error);
    }
  );

  return instance;
};
